import { render, staticRenderFns } from "./membership_upgrade_record_detail.vue?vue&type=template&id=2214217a"
import script from "./membership_upgrade_record_detail.vue?vue&type=script&lang=js"
export * from "./membership_upgrade_record_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports